import { Check, RefreshCw } from "lucide-react";
import { btnPrimaryClass, btnSecondarySmClass, inputBaseClass } from "./constants";
import { ApiResponsePre, SectionCard } from "./shared";

export function LexAiServicesTab({
  lexaiApiId,
  setLexaiApiId,
  lexaiResponse,
  lexaiEvents,
  loadLexAIEventsList,
  onEnableLexAi
}) {
  return (
    <>
      <div className="mb-5">
        <SectionCard
          title="Enable LexAI API"
          subtitle="One-click enable a LexAI/NativeOrange provider API for your organization (no credentials needed)"
        >
          <div className="flex flex-wrap gap-3 items-end">
            <div className="flex flex-col gap-1 min-w-[240px] flex-[2]">
              <label className="text-xs font-medium text-gray-600">Provider API ID</label>
              <input
                className={inputBaseClass}
                value={lexaiApiId}
                onChange={(e) => setLexaiApiId(e.target.value)}
                placeholder="UUID of the LexAI provider API"
              />
            </div>
            <button type="button" onClick={onEnableLexAi} className={btnPrimaryClass}>
              <Check className="w-4 h-4" />
              Enable
            </button>
          </div>
          <ApiResponsePre ok={lexaiResponse?.ok} text={lexaiResponse?.text} />
        </SectionCard>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h2 className="text-[15px] font-semibold text-gray-900">
              Subscribable Events
            </h2>
            <p className="text-xs text-gray-500 mb-0">
              LexAI event types you can subscribe webhook notifications to
            </p>
          </div>
          <button
            type="button"
            onClick={() => loadLexAIEventsList()}
            className={btnSecondarySmClass}
          >
            <RefreshCw className="w-3.5 h-3.5" />
            Refresh
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200 bg-gray-50">
                <th className="text-left py-2.5 px-3 text-[11px] font-semibold uppercase text-gray-500">
                  Service
                </th>
                <th className="text-left py-2.5 px-3 text-[11px] font-semibold uppercase text-gray-500">
                  Event Name
                </th>
                <th className="text-left py-2.5 px-3 text-[11px] font-semibold uppercase text-gray-500">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              {!lexaiEvents.length ? (
                <tr>
                  <td colSpan={3} className="py-10 text-center text-gray-400">
                    Click Refresh to load events.
                  </td>
                </tr>
              ) : (
                lexaiEvents.map((e) => (
                  <tr key={e.id} className="border-b border-gray-100 hover:bg-slate-50/80">
                    <td className="py-3 px-3">
                      <span className="inline-flex px-2 py-0.5 rounded-full text-[11px] font-semibold bg-violet-50 text-violet-700">
                        {e.service_name}
                      </span>
                    </td>
                    <td className="py-3 px-3">
                      <code className="bg-gray-100 px-2 py-0.5 rounded text-xs">
                        {e.event_name}
                      </code>
                    </td>
                    <td className="py-3 px-3 text-xs text-gray-600">
                      {e.description || "—"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
